import { isEmpty, map, merge } from 'lodash';
import React from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { PropTypes } from 'prop-types';
import { Trans } from 'react-i18next';

const PayerDropdown = ({
  items,
  noItemsText = <Trans i18nKey="components.dropdown.noItemsConfigured" />,
  selectedItem,
  noSelectedItemText = <Trans i18nKey="components.dropdown.selectItem" />,
  onItemSelect,
  disabled = false,
}) => {
  const menuItems = map(items, (item, id) => (
    <DropdownItem key={id} onClick={() => onItemSelect && onItemSelect(id)}>
      {item}
    </DropdownItem>
  ));

  return (
    <UncontrolledDropdown>
      <DropdownToggle caret disabled={disabled}>
        {items[selectedItem] ?? noSelectedItemText}
      </DropdownToggle>
      <DropdownMenu
        modifiers={{
          setMaxHeight: {
            enabled: true,
            order: 890,
            fn: data => merge(data, { styles: { maxHeight: '20rem', overflow: 'auto' } }),
          },
        }}
      >
        {!isEmpty(menuItems) ? menuItems : <DropdownItem disabled={true}>{noItemsText}</DropdownItem>}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

PayerDropdown.propTypes = {
  items: PropTypes.object,
  noItemsText: PropTypes.node,
  selectedItem: PropTypes.string,
  noSelectedItemText: PropTypes.node,
  onItemSelect: PropTypes.func,
  disabled: PropTypes.bool,
};

export { PayerDropdown };
